module.exports = __webpack_public_path__ + "static/carte-d972308459170ca4e7b6e5d78612ac31.png";